import * as THREE from "three";

exports.Unify = function(unify) {
  this.unify_id = "environment";

  // bg map
  const loader = new THREE.CubeTextureLoader();
  loader.setPath("textures/skybox/");
  let textureCube = loader.load(["px.png", "nx.png", "py.png", "ny.png", "pz.png", "nz.png"]);
  unify.scene.background = textureCube;

  var directionalLight = new THREE.DirectionalLight(0xffffff, 1);
  unify.scene.add(directionalLight);
  var light = new THREE.AmbientLight(0x555555);
  unify.scene.add(light);

  // "clouds"
  const numClouds = 200;
  const clouds = new THREE.Group();
  clouds.name = "clouds";
  for (let i = 0; i < numClouds; i++) {
    let cloud = unify.create.cube(unify, "cloud");
    cloud.position.set(Math.random() * 1000 - 500, Math.random() * 25 + 35, Math.random() * 1000 - 500);
    cloud.scale.set(Math.random() * 10 + 10, Math.random() * 5 + 3, Math.random() * 10 + 10);
    clouds.add(cloud);
  }
  unify.scene.add(clouds);

  unify.scene.fog = new THREE.Fog(0xefd1b5, 100);
};
